// extracted by mini-css-extract-plugin
export var mainWrapper = "PortfolioList-module--mainWrapper--fROqs";